module.exports = __webpack_public_path__ + "static/img/3.b7853e6a.png";